var appConfig = {
  computed: {
    appContext() {
      return this.$store.getters["app/context"];
    },
    appReady() {
      return this.$store.getters["app/resources"] === 100;
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    userReady() {
      return this.$store.getters["user/ready"];
    }
  }
};

export default appConfig;
